import type { Profile } from '@/lib/queries/profile';

/**
 * Pure routing decision: given the auth/profile state, where should the root
 * index route send the user? Extracted so it can be unit-tested without
 * mounting the entire app.
 */
export function resolveLandingRoute(args: {
  hasSession: boolean;
  profile: Pick<
    Profile,
    'role' | 'creator_status' | 'onboarding_completed_at' | 'onboarding_path'
  > | null;
}): string {
  if (!args.hasSession) return '/auth/sign-in';
  if (!args.profile) return '/auth/sign-in';

  const { profile } = args;
  if (!profile.onboarding_completed_at && !profile.onboarding_path) {
    return '/onboarding/welcome';
  }

  // A pending applicant checking their status is a distinct, correct
  // destination — not a "home" — so this branch stays.
  if (profile.role === 'creator' && profile.creator_status === 'pending') {
    return '/creator/application-status';
  }

  // One home for everyone (Spec 28 A1). Admin, moderator, approved creator,
  // founder, and reader all land on the reader dashboard — tools are entered
  // from there, never fallen into. The extra click into /admin or /creator is
  // the deliberate cost of always knowing where home is.
  return '/subscriber';
}
